import React, { useState } from 'react';
import ReactJson from 'react-json-view';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import CardTitleHeader from './CardTitleHeader';
const style = {
  overflowY: 'auto',
  height: '300px',
};
const ShowResponseDataApi = ({ responseData, handleBtnClick }) => {
  const [toggleModal, setToggleModal] = useState(false);
  if (!responseData || responseData.length === 0) {
    return '';
  }
  return (
    <>
      <Modal
        isOpen={toggleModal}
        toggle={() => setToggleModal(!toggleModal)}
        backdrop="static"
        className="modal-full-size"
        contentClassName="modal-content-full-size"
      >
        <ModalHeader toggle={() => setToggleModal(!toggleModal)} className="border-bottom">
          <strong>Response</strong>
        </ModalHeader>
        <ModalBody>
          <div style={{ ...style, height: '85vh' }}>
            {responseData && (
              <ReactJson
                name={false}
                iconStyle={'triangle'}
                enableClipboard={true}
                src={responseData}
                collapseStringsAfterLength={20}
              />
            )}
          </div>
        </ModalBody>
      </Modal>
      <div className="card">
        <div className="card-header card-header-text" data-background-color="drapcode-violet">
          <h6 className="card-title pb-0 mb-0 text-capitalise">Response</h6>
        </div>
        <i
          className="webconnect webconnect-fullscreen float-right p-3"
          style={{ cursor: 'pointer' }}
          onClick={() => setToggleModal(true)}
        />
        <div className="card-content">
          <CardTitleHeader />
          <div className="row">
            <div className="col-md-12 col-lg-12 mt-2">
              <div style={style}>
                <ReactJson
                  name={false}
                  iconStyle={'triangle'}
                  enableClipboard={true}
                  src={responseData}
                  collapseStringsAfterLength={20}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ShowResponseDataApi;
